export const ALERT_UNREAD_WINDOW_DAYS = 14; // TODO find a better file for this
//# sourceMappingURL=storeAlertCutoff.js.map